import { ContentCard } from '@ctw/shared/components/containers/content-card';
import { DefinitionList } from '@ctw/shared/components/definition-list';
import type { UseResourceDrawerOpenDrawerArgs } from '@ctw/shared/context/resource-drawer-context';
import { tw } from '@ctw/shared/utils/tailwind';
import { capitalize } from 'lodash-es';

/**
 * Renders ExplanationOfBenefits (currently only RiskDiagnosisModel) in the resource drawer.
 */
export const explanationOfBenefitDrawerAction: UseResourceDrawerOpenDrawerArgs<'ExplanationOfBenefit'>['action'] =
  ({ model }) => ({
    label: model.shortTitle,
    // Keep the diagnosis (ICD-10) codes out of the drawer title; show the date of
    // service instead (the ICD-10 list still appears in the details list below).
    title: model.serviceDate ?? model.shortTitle,
    content: {
      body: (
        <div className={tw`flex flex-col gap-5`}>
          <ContentCard variant="focal" title="Details">
            <DefinitionList
              items={[
                {
                  label: 'Claim Type',
                  value: model.claimType ? capitalize(model.claimType) : 'n/a',
                },
                { label: 'Date of Service', value: model.serviceDate ?? 'n/a' },
                { label: 'Risk Eligible', value: model.riskEligible ? 'Yes' : 'No' },
                { label: 'Provider', value: model.providerDisplay ?? 'Unknown' },
                { label: 'Insurer', value: model.insurerDisplay ?? 'Unknown' },
                // ICD-10 diagnoses render last in the details list.
                { label: 'ICD-10', value: model.icd10Codes.join(', ') || 'n/a' },
              ]}
            />
          </ContentCard>
        </div>
      ),
    },
  });
